module.exports = __webpack_public_path__ + "static/media/hitpaw-watermark-remover-box.0a12cf97.png";